import { useCallback, useState } from 'react';
import { WhatsAppApi } from '../api/resources';
import { usePolling } from '../hooks/useRequests';

/** Total unread WhatsApp messages, polled while the panel is open and the tab is visible. */
export default function useWhatsAppUnread(enabled) {
  const [count, setCount] = useState(0);
  const pull = useCallback(() => {
    WhatsAppApi.unreadCount()
      .then(setCount)
      .catch(() => {});
  }, []);
  usePolling(pull, 15000, enabled);
  return count;
}
